import { render, staticRenderFns } from "./BuckCorp.vue?vue&type=template&id=71279892&"
import script from "./BuckCorp.vue?vue&type=script&lang=ts&"
export * from "./BuckCorp.vue?vue&type=script&lang=ts&"
import style0 from "./BuckCorp.vue?vue&type=style&index=0&id=71279892&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports